<template>
  <div>
    <!-- actions -->
    <b-row class="pb-3">
      <!-- search -->
      <b-col cols="auto">
        <b-input-group>
        <b-form-input
          v-model="filter"
          @keyup.enter="buscar()"
          @keyup.esc="cancelFilterSearch()"
          type="text" placeholder="Buscar..."></b-form-input>
        <b-input-group-append>
          <b-button @click="buscar()"  variant="outline-secondary"><b-icon icon="search"/></b-button>
          <b-button @click="cancelFilterSearch()"
          v-if="filter !== ''" variant="outline-secondary"><b-icon icon="x"/></b-button>
        </b-input-group-append>
      </b-input-group>
      </b-col>
      <!-- add -->
      <b-col class="ml-auto">
        <b-button
        id="buttonmasclase"
        @click="openPopNewFamily()"
        class="btn-agregar-modelo"
        variant="primary"
        >
        <b-icon icon="plus"></b-icon>Agregar
      </b-button>
      </b-col>
    </b-row>
    <!--loading -->
    <div v-if="isLoading">
      <div class="text-center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </div>
    <div v-if="!isLoading">
      <b-row  v-if="families.length == 0">
        <b-col>
          <h5>Ingrese un texto para filtrar por nombre de grupo familiar o Alumno</h5>
        </b-col>
      </b-row>
      <b-row  v-if="families.length > 0">
        <b-col>
          <!-- table results -->
          <b-card no-body>
            <b-table hover :items="families" :fields="fields">
              <template #cell(display_name)="data">
                <b-avatar icon="people-fill" variant="primary" v-if="data.item.is_company"></b-avatar>
                <b-avatar icon="person" v-if="!data.item.is_company"></b-avatar>
                <b-link @click="ver(data.item)" class="ml-2" style="font-size:1.2em">{{ data.item.display_name}}</b-link>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modal-nueva-familia" title="Nueva Familia">
      <form>
        <b-form-group label="Apellido de Grupo Familiar" label-for="input-apellido">
          <b-form-input id="input-apellido" v-model="NewFamily.name"></b-form-input>
        </b-form-group>
        <b-form-group label="Nombre de Facturación" label-for="input-x_contact_name">
          <b-form-input id="input-x_contact_name" v-model="NewFamily.x_contact_name"></b-form-input>
        </b-form-group>
        <b-form-group label="DNI de Facturación" label-for="input-dni">
          <b-form-input id="input-dni" v-model="NewFamily.vat"></b-form-input>
        </b-form-group>
        <b-form-group label="Dirección de Facturación" label-for="input-street">
          <b-form-input id="input-street" v-model="NewFamily.street"></b-form-input>
        </b-form-group>
        <b-form-group label="Correo Electrónico" label-for="input-email">
          <b-form-input id="input-email" v-model="NewFamily.email"></b-form-input>
        </b-form-group>
        <b-form-group label="Teléfono" label-for="input-phone">
          <b-form-input id="input-phone" v-model="NewFamily.phone"></b-form-input>
        </b-form-group>
      </form>
      <template #modal-footer="{ cancel }">
        <b-button variant="outline-primary" @click="cancel()">
          Cancelar
        </b-button>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="primary" @click="createFamily()">
          Crear
        </b-button>

      </template>
    </b-modal>
  </div>
</template>

<script>
// import { YearsService } from '@/services/years.service'
import { FamiliesService } from '@/services/families.service'
import { L10nLatamIdentificationTypeService } from '@/services/l10n_latam.identification.type.service'
import { L10nArAfipResponsabilityTypeService } from '@/services/l10n_ar.afip.responsibility.type.service'

export default {
  name: 'Families',
  data () {
    return {
      isLoading: false,
      fields: [
        { key: 'display_name', label: 'Nombre' }
      ],
      NewFamily: {},
      families: [],
      year: null,
      filter: '',
      provincias: [],
      selectedProv: 575,
      searchFilter: ''
    }
  },
  computed: {
    provOptions () {
      return this.provincias.map(function (item) {
        return { value: item.id, text: item.name }
      })
    }
  },
  async created () {
    console.log(this.$store.state.family)
    this.families = []
    console.log(this.provincias)
  },
  methods: {
    async createFamily () {
      console.log(this.NewFamily)

      this.NewFamily.company_type = 'company'
      this.NewFamily.l10n_latam_identification_type_id = (await L10nLatamIdentificationTypeService.search({ name: 'DNI' }))[0]
      this.NewFamily.l10n_ar_afip_responsibility_type_id = (await L10nArAfipResponsabilityTypeService.search({ name: 'Consumidor Final' }))[0]
      console.log(this.NewFamily)

      try {
        const newFamId = await FamiliesService.create(this.NewFamily)
        console.log(newFamId)
        await this.$router.push({ path: '/families/' + newFamId })
      } catch (error) {
        console.log(error)
      }
    },
    openPopNewFamily () {
      this.$bvModal.show('modal-nueva-familia')
    },
    async buscar () {
      this.isLoading = true
      this.families = await FamiliesService.list(['display_name', 'ilike', this.filter])
      this.isLoading = false
    },
    ver (data) {
      console.log(data)
      data.is_company ? this.$router.push(`/families/${data.id}`) : this.$router.push(`/families/${data.parent_id[0]}`)
    },
    cancelFilterSearch () {
      this.filter = ''
      this.families = []
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
